import React from 'react';

import Layout from 'components/layout/Layout';
import { PageMetaRepo } from 'domain/repositories';
import { PageMeta } from 'domain/types';
import Delivery from 'components/delivery/Delivery';

interface Props {
  pageMeta: PageMeta;
}

const DeliveryPage: React.FC<Props> = ({ pageMeta }): JSX.Element => {
  return (
    <Layout pageMeta={{ ...pageMeta, title: 'Доставка та оплата' }} showTitleTag>
      <Delivery />
    </Layout>
  );
};

export const getStaticProps = async () => {
  const pageMeta = await PageMetaRepo.getDefault();

  return {
    props: {
      pageMeta
    }
  };
};

export default DeliveryPage;
